"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GamemodeSettingsPresets = void 0;
exports.GamemodeSettingsPresets = {
    default: {
        healthLostPerPiece: 2,
        startingMoney: 3,
        startingLevel: 1,
        rerollCost: 2,
        rerollMultiplier: 100,
        buyXpCost: 5,
        buyXpAmount: 4,
        boardWidth: 7,
        boardHalfHeight: 3,
        benchSize: 9,
        battleTurnCount: 300,
        battleTurnDuration: 100,
        preparingPhaseLengthMs: 60000,
        readyPhaseSettleMs: 500,
        readyPhaseLengthMs: 6000,
        playingPhaseMaxLengthMs: 35000,
        playingPhaseEndDelayMs: 5000,
        postBattleSettleMs: 1000,
        postMatchSettleMs: 500,
        botInitialDelayMs: 1000,
        botActionDelayMs: 400,
        gameStartSettleMs: 100,
        botSelectionTemperature: 0.025,
    },
};
